// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM9.29305 18.2072L6.08594 15.0001L9.29304 11.793L10.7073 13.2072L8.91437 15.0001L10.7073 16.793L9.29305 18.2072ZM13.2929 16.793L15.0858 15.0001L13.2929 13.2072L14.7071 11.793L17.9142 15.0001L14.7071 18.2072L13.2929 16.793Z"}}]};

const FileCode1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-code-1-filled',
    ref,
    icon: element,
  },
));

FileCode1FilledIcon.displayName = 'FileCode1FilledIcon';

export default FileCode1FilledIcon;
